export { default as StrategyHistory } from './StrategyHistory';
